import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { UserListComponent } from '../user-list/user-list.component';
import { WirelessCreateComponent } from '../wireless-create/wireless-create.component';

@Component({
  selector: 'app-wireless-user-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./wireless-user-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class WirelessUserListComponent extends UserListComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: UserService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.subentity = 'wireless';
    this.form = WirelessCreateComponent;
  }

  getBody() {
    const body = super.getBody();
    let query = ['service_type', '=', this.subentity.toUpperCase()] as any[];
    if (this.building_id || this.body.building_id) {
      query = [
        query,
        'and',
        ['building_id', '=', this.building_id || this.body.building_id]
      ];
    }
    if (body.query) {
      body.query = [body.query, 'and', query];
    } else {
      body.query = query;
    }
    return body;
  }


}
